/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_Dateunavailable1Inputs */

const id_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const ms_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const da_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const de_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const en_us2_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const es_es2_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de observación no disponible`)
};

const es_mx2_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de observación no disponible`)
};

const fil_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const fr_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const it_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const hu_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const nl_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const no_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const pl_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const pt_br2_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const pt_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const ro_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const fi_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const sv_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const vi_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const tr_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const cs_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const bg_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const ru_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата наблюдения недоступна`)
};

const uk_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const ar_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const hi_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देखे जाने की तारीख उपलब्ध नहीं`)
};

const th_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีวันที่พบ`)
};

const ja_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const zh_cn2_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

const zh_hant1_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法取得觀察日期`)
};

const ko_builds_timeline_dateunavailable1 = /** @type {(inputs: Builds_Timeline_Dateunavailable1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed date unavailable`)
};

/**
* | output |
* | --- |
* | "Observed date unavailable" |
*
* @param {Builds_Timeline_Dateunavailable1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_dateunavailable1 = /** @type {((inputs?: Builds_Timeline_Dateunavailable1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_Dateunavailable1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_dateunavailable1(inputs)
	if (locale === "ms") return ms_builds_timeline_dateunavailable1(inputs)
	if (locale === "da") return da_builds_timeline_dateunavailable1(inputs)
	if (locale === "de") return de_builds_timeline_dateunavailable1(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_dateunavailable1(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_dateunavailable1(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_dateunavailable1(inputs)
	if (locale === "fil") return fil_builds_timeline_dateunavailable1(inputs)
	if (locale === "fr") return fr_builds_timeline_dateunavailable1(inputs)
	if (locale === "it") return it_builds_timeline_dateunavailable1(inputs)
	if (locale === "hu") return hu_builds_timeline_dateunavailable1(inputs)
	if (locale === "nl") return nl_builds_timeline_dateunavailable1(inputs)
	if (locale === "no") return no_builds_timeline_dateunavailable1(inputs)
	if (locale === "pl") return pl_builds_timeline_dateunavailable1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_dateunavailable1(inputs)
	if (locale === "pt") return pt_builds_timeline_dateunavailable1(inputs)
	if (locale === "ro") return ro_builds_timeline_dateunavailable1(inputs)
	if (locale === "fi") return fi_builds_timeline_dateunavailable1(inputs)
	if (locale === "sv") return sv_builds_timeline_dateunavailable1(inputs)
	if (locale === "vi") return vi_builds_timeline_dateunavailable1(inputs)
	if (locale === "tr") return tr_builds_timeline_dateunavailable1(inputs)
	if (locale === "cs") return cs_builds_timeline_dateunavailable1(inputs)
	if (locale === "bg") return bg_builds_timeline_dateunavailable1(inputs)
	if (locale === "ru") return ru_builds_timeline_dateunavailable1(inputs)
	if (locale === "uk") return uk_builds_timeline_dateunavailable1(inputs)
	if (locale === "ar") return ar_builds_timeline_dateunavailable1(inputs)
	if (locale === "hi") return hi_builds_timeline_dateunavailable1(inputs)
	if (locale === "th") return th_builds_timeline_dateunavailable1(inputs)
	if (locale === "ja") return ja_builds_timeline_dateunavailable1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_dateunavailable1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_dateunavailable1(inputs)
	return ko_builds_timeline_dateunavailable1(inputs)
});
export { builds_timeline_dateunavailable1 as "builds.timeline.dateUnavailable" }